@if (loaded) {
  <ng-container [formGroup]="formGroup">
    <div class="row pb-2">
      <div class="col-md-6">
        <app-edit-asset-details
          #EditDetails
          [asset]="asset"
          [form]="formGroup"
          [listFieldsResponse]="listFieldsResponse"
          [parentAsset]="parentAsset"
          [classificationDefaults]="classificationDefaults"
        ></app-edit-asset-details>
        <hr class="d-block d-md-none" />
      </div>
      <div class="col-md-6">
        @if (showSettings) {
          <app-depreciation-method-selector
            #methodSelector
            [register]="register"
            [showTaxableUse]="true"
            [regimeData]="EditDetails.currentGroup?.assetGroupRegimes"
            [allowBlankSettings]="false"
            [formGroup]="formGroup"
            [acquisitionDate]="formGroup.controls.acquisitionDate.value"
            [firstUseDate]="formGroup.controls.firstUseDate.value"
            [isFirstUse]="true"
            [taxableUse]="formGroup.controls.taxableUse.value"
            [acquisitionPrice]="formGroup.controls.purchasePrice.value"
            [forceDefaultDepreciationSettings]="true"
            [poolsByRegime]="poolsByRegime"
          ></app-depreciation-method-selector>
        }
      </div>
    </div>
    @if (showSettings && !hasGroupDefaultSettings) {
      <div class="col-12 mt-1 mb-4">
        <div class="d-flex justify-content-end form-section">
          <div class="checkbox-enhanced">
            <input
              data-dd-action-name="new-asset-details.save-settings-checkbox"
              id="save-settings"
              type="checkbox"
              [(ngModel)]="saveDepreciationSettings"
              [ngModelOptions]="{ standalone: true }"
            />
            <label for="save-settings">
              Save depreciation settings as default for Asset Group
            </label>
          </div>
        </div>
      </div>
    }
  </ng-container>
} @else {
  <app-loading></app-loading>
}
